module.exports = __webpack_public_path__ + "img/kc11.74eecf65.png";